import * as v from 'valibot'

import { APP_LOCALE, CONTENT_LOCALE } from '@/locale/constants'

export const localStorageSchema = {
  afterLogin: v.optional(v.string()),
  'assigned-courses-filters': v.strictObject({
    categoryId: v.optional(v.string()),
    state: v.optional(v.picklist(['active', 'completed'])),
    types: v.optional(v.array(v.picklist(['linear', 'certificate']))),
  }),
  'assigned-learnpaths-filters': v.strictObject({
    categoryId: v.optional(v.string()),
    state: v.optional(v.picklist(['active', 'overdue', 'completed'])),
    types: v.optional(
      v.array(v.picklist(['mandatory', 'linear', 'certificate'])),
    ),
  }),
  'growth-map-show-completed-courses': v.optional(v.boolean(), false),
  keycloak: v.optional(v.string()),
  'managed-courses-filters': v.strictObject({
    categoryId: v.optional(v.string()),
    language: v.optional(v.picklist(CONTENT_LOCALE)),
    owner: v.optional(v.literal('myself')),
    status: v.optional(v.picklist(['active', 'draft', 'inactive'])),
    types: v.optional(v.array(v.picklist(['linear', 'certificate'])), []),
  }),
  'managed-learnpaths-preferences': v.strictObject({
    only_direct_learners_stats: v.optional(v.boolean(), true),
  }),
  'managed-learnpaths-filters': v.looseObject({
    categoryId: v.optional(v.string()),
    group: v.optional(v.looseObject({ id: v.string(), name: v.string() })),
    language: v.fallback(v.optional(v.picklist(CONTENT_LOCALE)), undefined),
    ownership: v.optional(
      v.picklist(['all', 'myself', 'my-learners']),
      'all' as const,
    ),
    status: v.optional(
      v.picklist(['active', 'scheduled', 'draft', 'inactive']),
    ),
    types: v.optional(
      v.array(v.picklist(['mandatory', 'linear', 'certificate'])),
      [],
    ),
    user: v.fallback(v.optional(v.string()), undefined),
  }),
  locale: v.optional(v.picklist(APP_LOCALE)),
  masterplan: v.any(),
  'mp-manager-sidebar-status': v.optional(
    v.picklist(['collapsing', 'collapsed', 'expanding', 'expanded']),
    'expanded',
  ),
  'masterplan-timezone-picker': v.optional(v.array(v.string()), []),
  'media-player-audio-locale': v.optional(v.string()),
  persistAll: v.optional(v.boolean()),
  seen_notifications: v.fallback(
    v.strictObject({
      'radar animation seen': v.boolean(),
      outdated_browser: v.boolean(),
    }),
    {
      'radar animation seen': false,
      outdated_browser: false,
    },
  ),
  shouldShowAssessmentAnimation: v.optional(v.boolean(), false),
  sidebarExpandableMenu: v.optional(v.boolean(), true),
  // typo inherited from old implementation
  sibebarLabelsAlwaysOn: v.optional(v.boolean(), true),
  theme: v.optional(v.picklist(['light', 'dark'])),
  video_player_params: v.optional(v.record(v.string(), v.any())),
}

export type LocalStorageKey = keyof typeof localStorageSchema

export type LocalStorageValue<K extends LocalStorageKey> = v.InferOutput<
  (typeof localStorageSchema)[K]
>
